module.exports = __webpack_public_path__ + "img/head portrait_logged in.dc0d1f2f.png";